<div>
  <h6 class="odx-title-6" i18n="@@global.pipelines">Rohrleitungen</h6>

  <app-floorplan-menu-item-buttons>
    <app-add-button
      (add)="addPipeline()"
      [odxTooltip]="tooltipTextAddPipeline"
      [odxTooltipOptions]="{ position: 'bottom' }"
      (dragStart)="dragPipeline()"
    ></app-add-button>
    <app-toggle-visibility-button
      [visible]="floorplanState.pipelinesVisible"
      (toggleEvent)="floorplanState.pipelinesVisible = $event"
    >
    </app-toggle-visibility-button>
    <app-toggle-item-text-visibility-button
      [itemTextVisible]="floorplanState.pipelinesItemTextVisible"
      (toggleEvent)="updatePipelinesItemTextVisibility($event)"
    ></app-toggle-item-text-visibility-button>
    <app-toggle-lock-button [locked]="floorplanState.pipelinesLocked" (toggleEvent)="floorplanState.pipelinesLocked = $event">
    </app-toggle-lock-button>
  </app-floorplan-menu-item-buttons>
</div>
